// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pI0N","newExpiryDate":"styles_newExpiryDate__3vosM","footer":"styles_footer__zIT_x"};